import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27ddb0aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-3 text-error"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-3 text-success"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  class: "d-flex justify-space-between align-center",
  style: {"width":"100%"}
}
const _hoisted_7 = { class: "ml-3 text-caption" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Description:", -1))
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Available in Free:", -1))
const _hoisted_12 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Words:", -1))
const _hoisted_14 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Topics:", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "mb-2 d-block" }, "Topics:", -1))
const _hoisted_18 = {
  class: "d-flex justify-space-between align-center",
  style: {"width":"100%"}
}
const _hoisted_19 = {
  key: 0,
  class: "ml-3 text-caption"
}
const _hoisted_20 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Description:", -1))
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Available in Free:", -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Words in Topic:", -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Progress:", -1))
const _hoisted_28 = {
  key: 0,
  class: "text-caption mt-2"
}
const _hoisted_29 = {
  key: 3,
  class: "text-caption mt-2"
}

import { ref, onMounted, reactive, watch, computed } from "vue";
import axios, { AxiosError } from "axios";
import { useCourseStore } from "@/store/courseStore";

// Type definitions
type CourseType = "LANGUAGE_LEVEL" | "SUBJECT" | "SCHOOL_COURSE" | "COMPANY_COURSE";
type CourseLanguage = "RU" | "EN";

interface Course {
  id: string;
  name: string;
  description?: string;
  type: CourseType;
  courseLanguage: CourseLanguage;
  availableInFree: boolean;
  wordCount?: number;
  topicCount?: number;
  userEnrollment?: {
    completedWords?: number;
    completedSentences?: number;
  };
}

interface Topic {
  id: string;
  name: string;
  description?: string;
  courseId: string;
  availableInFree: boolean;
  wordCount?: number;
  completedWords?: number;
  completedSentences?: number;
}

interface CourseForUpload {
  id: string;
  name: string;
}

interface CreateCoursePayload {
  name: string;
  description?: string;
  type: CourseType;
  courseLanguage: CourseLanguage;
  availableInFree: boolean;
}

// Enums from backend

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardCourses',
  setup(__props) {

const courseTypeOptions = [
  { title: "Language Level", value: "LANGUAGE_LEVEL" },
  { title: "Subject", value: "SUBJECT" },
  { title: "School Course", value: "SCHOOL_COURSE" },
  { title: "Company Course", value: "COMPANY_COURSE" },
];

const courseLanguageOptions = [
  { title: "Russian", value: "RU" },
  { title: "English", value: "EN" },
];

// Store
const courseStore = useCourseStore();

// Computed
const isSchoolUser = computed(() => courseStore.isSchoolUser);

// State
const showCreateForm = ref(false);
const isLoadingCourses = ref(false);
const isCreating = ref(false);
const isUploading = ref(false);
const isUpdating = ref(false);
const courses = ref<Course[]>([]);
const coursesForUpload = ref<CourseForUpload[]>([]);
const selectedCourseForUpload = ref<string | null>(null);
const uploadFile = ref<File | File[] | null>(null);
const uploadError = ref("");
const uploadSuccess = ref("");
const expandedCourses = ref<string[]>([]);
const courseTopics = ref<Record<string, Topic[]>>({});
const expandedTopics = ref<Record<string, string[]>>({});
const loadingTopics = ref<Record<string, boolean>>({});

// Forms
const createFormRef = ref<InstanceType<typeof import("vuetify/components").VForm> | null>(null);
const editFormRef = ref<InstanceType<typeof import("vuetify/components").VForm> | null>(null);

const newCourse = reactive<CreateCoursePayload>({
  name: "",
  description: "",
  type: "LANGUAGE_LEVEL",
  courseLanguage: "RU",
  availableInFree: false,
});

const editingCourse = reactive<CreateCoursePayload & { id: string }>({
  id: "",
  name: "",
  description: "",
  type: "LANGUAGE_LEVEL",
  courseLanguage: "RU",
  availableInFree: false,
});

const showEditDialog = ref(false);

// Validation rules
const rules = {
  required: (value: unknown): boolean | string => !!value || "This field is required",
  maxLength: (max: number) => (value: string): boolean | string =>
    !value || value.length <= max || `Maximum ${max} characters`,
  fileFormat: (files: File[] | null): boolean | string => {
    if (!files || files.length === 0) return true;
    const file = files[0];
    return (
      file.name.endsWith(".xlsx") ||
      "File must be an Excel file (.xlsx)"
    );
  },
  fileSize: (files: File[] | null): boolean | string => {
    if (!files || files.length === 0) return true;
    const file = files[0];
    const maxSize = 1000000; // 1MB in bytes
    return file.size <= maxSize || "File size must be less than 1MB";
  },
};

// Fetch all courses
async function fetchCourses() {
  isLoadingCourses.value = true;
  try {
    const response = await axios.get("/api/course/list");
    courses.value = response.data;
    coursesForUpload.value = response.data.map((course: Course) => ({
      id: course.id,
      name: `${course.name} (${course.type})`,
    }));
  } catch (error: unknown) {
    console.error("Failed to fetch courses", error);
    const errorMessage = error instanceof Error ? error.message : "Unknown error";
    alert("Failed to load courses: " + errorMessage);
  } finally {
    isLoadingCourses.value = false;
  }
}

// Create new course
async function createCourse() {
  if (!createFormRef.value) return;
  const { valid } = await createFormRef.value.validate();
  if (!valid) return;

  isCreating.value = true;
  try {
    const response = await axios.post("/api/course", newCourse);
    uploadSuccess.value = `Course "${response.data.name}" created successfully!`;
    uploadError.value = "";
    
    // Reset form
    Object.assign(newCourse, {
      name: "",
      description: "",
      type: "LANGUAGE_LEVEL",
      courseLanguage: "RU",
      availableInFree: false,
    });
    showCreateForm.value = false;
    
    // Refresh courses list
    await fetchCourses();
    
    // Auto-select newly created course for upload
    selectedCourseForUpload.value = response.data.id;
  } catch (error: unknown) {
    console.error("Failed to create course", error);
    if (error instanceof AxiosError && error.response?.data) {
      const data = error.response.data as { message?: string };
      alert("Failed to create course: " + (data.message || "Unknown error"));
    } else {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      alert("Failed to create course: " + errorMessage);
    }
  } finally {
    isCreating.value = false;
  }
}

function cancelCreate() {
  showCreateForm.value = false;
  Object.assign(newCourse, {
    name: "",
    description: "",
    type: "LANGUAGE_LEVEL",
    courseLanguage: "RU",
    availableInFree: false,
  });
}

// Upload materials
async function uploadMaterials() {
  if (!selectedCourseForUpload.value || !uploadFile.value) {
    uploadError.value = "Please select a course and file";
    return;
  }

  // Handle v-file-input: it can return File | File[] | null
  let file: File | null = null;
  if (uploadFile.value instanceof File) {
    file = uploadFile.value;
  } else if (Array.isArray(uploadFile.value) && uploadFile.value.length > 0) {
    file = uploadFile.value[0];
  }
  
  if (!file) {
    uploadError.value = "Please select a file";
    return;
  }

  // Validate file
  if (!file.name.endsWith(".xlsx")) {
    uploadError.value = "File must be an Excel file (.xlsx)";
    return;
  }
  
  if (file.size > 1000000) {
    uploadError.value = "File size must be less than 1MB";
    return;
  }

  isUploading.value = true;
  uploadError.value = "";
  uploadSuccess.value = "";

  try {
    const formData = new FormData();
    formData.append("file", file);

    await axios.post(
      `/api/files/course/${selectedCourseForUpload.value}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    uploadSuccess.value = "Materials uploaded successfully!";
    uploadFile.value = null;
    
    // Reload topics for the course if already expanded
    if (selectedCourseForUpload.value && expandedCourses.value.includes(selectedCourseForUpload.value)) {
      await loadCourseTopics(selectedCourseForUpload.value);
    }
  } catch (error: unknown) {
    console.error("Failed to upload materials", error);
    if (error instanceof AxiosError && error.response?.data) {
      const data = error.response.data as { message?: string };
      uploadError.value = "Upload failed: " + (data.message || "Unknown error");
    } else {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      uploadError.value = "Upload failed: " + errorMessage;
    }
  } finally {
    isUploading.value = false;
  }
}

// Load topics for a course
async function loadCourseTopics(courseId: string) {
  if (courseTopics.value[courseId]) {
    return; // Already loaded
  }

  loadingTopics.value[courseId] = true;
  try {
    const response = await axios.get(`/api/course/${courseId}/topics`);
    courseTopics.value[courseId] = response.data;
    expandedTopics.value[courseId] = [];
  } catch (error: unknown) {
    console.error("Failed to load topics", error);
    courseTopics.value[courseId] = [];
  } finally {
    loadingTopics.value[courseId] = false;
  }
}

// Edit course
function openEditDialog(course: Course) {
  Object.assign(editingCourse, {
    id: course.id,
    name: course.name,
    description: course.description || "",
    type: course.type,
    courseLanguage: course.courseLanguage,
    availableInFree: course.availableInFree,
  });
  showEditDialog.value = true;
}

function closeEditDialog() {
  showEditDialog.value = false;
  Object.assign(editingCourse, {
    id: "",
    name: "",
    description: "",
    type: "LANGUAGE_LEVEL",
    courseLanguage: "RU",
    availableInFree: false,
  });
}

async function updateCourse() {
  if (!editFormRef.value) return;
  const { valid } = await editFormRef.value.validate();
  if (!valid) return;

  isUpdating.value = true;
  try {
    const updateData = {
      name: editingCourse.name,
      description: editingCourse.description || undefined,
      type: editingCourse.type,
      courseLanguage: editingCourse.courseLanguage,
      availableInFree: editingCourse.availableInFree,
    };

    await axios.patch(`/api/course/${editingCourse.id}`, updateData);
    
    uploadSuccess.value = "Course updated successfully!";
    uploadError.value = "";
    closeEditDialog();
    
    // Refresh courses list
    await fetchCourses();
    
    // Reload topics if they were loaded
    if (courseTopics.value[editingCourse.id]) {
      delete courseTopics.value[editingCourse.id];
      if (expandedCourses.value.includes(editingCourse.id)) {
        await loadCourseTopics(editingCourse.id);
      }
    }
  } catch (error: unknown) {
    console.error("Failed to update course", error);
    if (error instanceof AxiosError && error.response?.data) {
      const data = error.response.data as { message?: string };
      alert("Failed to update course: " + (data.message || "Unknown error"));
    } else {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      alert("Failed to update course: " + errorMessage);
    }
  } finally {
    isUpdating.value = false;
  }
}

// Watch for course expansion to auto-load topics
watch(expandedCourses, async (newExpanded, oldExpanded) => {
  const newlyExpanded = newExpanded.filter((id) => !oldExpanded.includes(id));
  for (const courseId of newlyExpanded) {
    await loadCourseTopics(courseId);
  }
});

onMounted(() => {
  fetchCourses();
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!

  return (_openBlock(), _createBlock(_component_v_window_item, { value: "materjalid" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        class: _normalizeClass({ 'school-courses-view': isSchoolUser.value })
      }, {
        default: _withCtx(() => [
          (!showCreateForm.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "mb-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateForm.value = true)),
                        variant: "elevated",
                        class: "text-none"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Create New Course ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showCreateForm.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 1,
                class: "mb-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Create New Course")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        ref_key: "createFormRef",
                        ref: createFormRef,
                        onSubmit: _withModifiers(createCourse, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: newCourse.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newCourse.name) = $event)),
                            label: "Course Name",
                            rules: [rules.required, rules.maxLength(100)],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_textarea, {
                            modelValue: newCourse.description,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newCourse.description) = $event)),
                            label: "Description (Optional)",
                            rules: [rules.maxLength(500)],
                            rows: "3",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_select, {
                            modelValue: newCourse.type,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newCourse.type) = $event)),
                            items: courseTypeOptions,
                            label: "Course Type",
                            rules: [rules.required],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_select, {
                            modelValue: newCourse.courseLanguage,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newCourse.courseLanguage) = $event)),
                            items: courseLanguageOptions,
                            label: "Course Language",
                            rules: [rules.required],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: newCourse.availableInFree,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newCourse.availableInFree) = $event)),
                            label: "Available in Free Tier",
                            class: "mb-3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                type: "submit",
                                variant: "elevated",
                                loading: isCreating.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Create Course ")
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createVNode(_component_v_btn, {
                                onClick: cancelCreate,
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cancel")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, { class: "mb-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Upload Materials to Course")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: selectedCourseForUpload.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedCourseForUpload).value = $event)),
                    items: coursesForUpload.value,
                    "item-title": "name",
                    "item-value": "id",
                    label: "Select Course",
                    class: "mb-3",
                    disabled: courses.value.length === 0
                  }, null, 8, ["modelValue", "items", "disabled"]),
                  _createVNode(_component_v_file_input, {
                    modelValue: uploadFile.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((uploadFile).value = $event)),
                    label: "Select Excel File (.xlsx)",
                    accept: ".xlsx",
                    rules: [rules.fileFormat, rules.fileSize],
                    disabled: !selectedCourseForUpload.value,
                    class: "mb-3"
                  }, null, 8, ["modelValue", "rules", "disabled"]),
                  _createVNode(_component_v_btn, {
                    onClick: uploadMaterials,
                    variant: "elevated",
                    disabled: !selectedCourseForUpload.value || !uploadFile.value,
                    loading: isUploading.value,
                    class: "text-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Upload Materials ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  (uploadError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(uploadError.value), 1))
                    : _createCommentVNode("", true),
                  (uploadSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(uploadSuccess.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("All Courses")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (isLoadingCourses.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading courses..."))
                    : (courses.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No courses found"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_expansion_panels, {
                            modelValue: expandedCourses.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((expandedCourses).value = $event)),
                            multiple: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (course) => {
                                return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                  key: course.id,
                                  value: course.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, _toDisplayString(course.name), 1),
                                            _createElementVNode("span", _hoisted_7, " (" + _toDisplayString(course.type) + " - " + _toDisplayString(course.courseLanguage) + ") ", 1)
                                          ]),
                                          _createVNode(_component_v_btn, {
                                            onClick: _withModifiers(($event: any) => (openEditDialog(course)), ["stop"]),
                                            icon: "mdi-pencil",
                                            size: "small",
                                            variant: "text",
                                            class: "mr-2"
                                          }, null, 8, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_expansion_panel_text, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                          _hoisted_9,
                                          _createTextVNode(" " + _toDisplayString(course.description || "No description"), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                          _hoisted_11,
                                          _createTextVNode(" " + _toDisplayString(course.availableInFree ? "Yes" : "No"), 1)
                                        ]),
                                        (course.wordCount !== undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                              _hoisted_13,
                                              _createTextVNode(" " + _toDisplayString(course.wordCount), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (course.topicCount !== undefined)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                              _hoisted_15,
                                              _createTextVNode(" " + _toDisplayString(course.topicCount), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (courseTopics.value[course.id])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                              _createVNode(_component_v_divider, { class: "my-3" }),
                                              _hoisted_17,
                                              _createVNode(_component_v_expansion_panels, {
                                                modelValue: expandedTopics.value[course.id],
                                                "onUpdate:modelValue": ($event: any) => ((expandedTopics.value[course.id]) = $event),
                                                multiple: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseTopics.value[course.id], (topic) => {
                                                    return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                                      key: topic.id,
                                                      value: topic.id
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_expansion_panel_title, null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_18, [
                                                              _createElementVNode("div", null, [
                                                                _createTextVNode(_toDisplayString(topic.name) + " ", 1),
                                                                (topic.wordCount)
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " (" + _toDisplayString(topic.wordCount) + " words) ", 1))
                                                                  : _createCommentVNode("", true)
                                                              ])
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_expansion_panel_text, null, {
                                                          default: _withCtx(() => [
                                                            (topic.description)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                                  _hoisted_21,
                                                                  _createTextVNode(" " + _toDisplayString(topic.description), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_22, [
                                                              _hoisted_23,
                                                              _createTextVNode(" " + _toDisplayString(topic.availableInFree ? "Yes" : "No"), 1)
                                                            ]),
                                                            (topic.wordCount !== undefined)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                  _hoisted_25,
                                                                  _createTextVNode(" " + _toDisplayString(topic.wordCount), 1)
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (topic.completedWords !== undefined && topic.completedSentences !== undefined)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                                  _hoisted_27,
                                                                  _createTextVNode(" " + _toDisplayString(topic.completedWords) + "/" + _toDisplayString(topic.wordCount) + " words, " + _toDisplayString(topic.completedSentences) + "/" + _toDisplayString(topic.wordCount) + " sentences ", 1)
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                              (courseTopics.value[course.id].length === 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, " No topics yet. Upload materials to add topics. "))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (loadingTopics.value[course.id])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Loading topics... "))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 4,
                                                onClick: ($event: any) => (loadCourseTopics(course.id)),
                                                size: "small",
                                                variant: "outlined",
                                                class: "mt-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Load Topics ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_dialog, {
            modelValue: showEditDialog.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((showEditDialog).value = $event)),
            "max-width": "600px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Edit Course")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        ref_key: "editFormRef",
                        ref: editFormRef,
                        onSubmit: _withModifiers(updateCourse, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: editingCourse.name,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editingCourse.name) = $event)),
                            label: "Course Name",
                            rules: [rules.required, rules.maxLength(100)],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_textarea, {
                            modelValue: editingCourse.description,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editingCourse.description) = $event)),
                            label: "Description (Optional)",
                            rules: [rules.maxLength(500)],
                            rows: "3",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_select, {
                            modelValue: editingCourse.type,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editingCourse.type) = $event)),
                            items: courseTypeOptions,
                            label: "Course Type",
                            rules: [rules.required],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_select, {
                            modelValue: editingCourse.courseLanguage,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editingCourse.courseLanguage) = $event)),
                            items: courseLanguageOptions,
                            label: "Course Language",
                            rules: [rules.required],
                            required: "",
                            class: "mb-3"
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_checkbox, {
                            modelValue: editingCourse.availableInFree,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editingCourse.availableInFree) = $event)),
                            label: "Available in Free Tier",
                            class: "mb-3"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_card_actions, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                type: "submit",
                                variant: "elevated",
                                loading: isUpdating.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Save Changes ")
                                ]),
                                _: 1
                              }, 8, ["loading"]),
                              _createVNode(_component_v_btn, {
                                onClick: closeEditDialog,
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Cancel")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})